import { SET_EMAIL } from 'actions';

export function setEmail(email: string) {
  return { email, type: SET_EMAIL };
}
